import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Button from "../button/Button";
import { isKeydownEscapeKey } from "../../../utils/keyboard.utils";
import { isIE } from "../../../utils/browser.utils";
import "./ModalContent.scss";

export default class ModalContent extends Component<any> {
  backgroundRef: any = React.createRef();

  /**
   * ie related refs
   */
  headerRef: any = React.createRef();
  contentRef: any = React.createRef();

  close = () => {
    if (this.props.onClose) this.props.onClose();
  };

  onKeyDown = ev => {
    if (isKeydownEscapeKey(ev)) {
      this.close();
    }
  };

  onBodyClick = ev => {
    if (ev.target === this.backgroundRef.current) {
      this.close();
    }
  };

  componentDidMount() {
    document.body.addEventListener("keydown", this.onKeyDown);
    document.body.addEventListener("click", this.onBodyClick);

    if (isIE()) {
      setTimeout(() => this.makeContentScrollable(), 0);
      window.addEventListener("resize", this.makeContentScrollable);
    }
  }

  componentWillUnmount() {
    document.body.removeEventListener("keydown", this.onKeyDown);
    document.body.removeEventListener("click", this.onBodyClick);

    if (isIE()) {
      window.removeEventListener("resize", this.makeContentScrollable);
    }
  }

  /**
   * ie fix.
   */
  makeContentScrollable = () => {
    const basePadding = 16; // px

    let modalContentMaxHeight =
      this.backgroundRef.current.clientHeight - 2 * basePadding;

    if (this.headerRef.current) {
      modalContentMaxHeight -= this.headerRef.current.clientHeight;
    }

    this.contentRef.current.setAttribute(
      "style",
      `max-height: ${modalContentMaxHeight}px`
    );
  };

  render() {
    const modalClassNames = classnames("modal", this.props.className, {
      "modal--full-height": this.props.fullHeight
    });
    return (
      <div className="modal-background" ref={this.backgroundRef}>
        <div className={modalClassNames} role="dialog">
          {this.props.header && (
            <header className="modal-header" ref={this.headerRef}>
              <h2 className="modal-header__title">{this.props.header}</h2>
            </header>
          )}

          <div className="modal__content" ref={this.contentRef}>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}
